module.exports = __webpack_public_path__ + "static/a11ytab-b4bd7906f38d789f50cc7c52c4849e96.png";